export const MAX_TEXT_WIDTH = 145;
export const TOOLTIP_CLOSE_DELAY = 500;
